import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import './App.css';
import { SnackbarProvider} from 'notistack';
import { VariantBs4, maxSnack} from './bs4/Bs4Snackbar';
import Bs4MainWindow, { TYPE_BS4_THEME, TYPE_A_LINK } from "./bs4/Bs4MainWindow";
import Bs4MainDispatch from "./bs4/Bs4MainDispatch";
import getBs4Theme from './bs4/Bs4Theme/Bs4Theme';
import {colorToHex, getColorLuminosity} from './bs4/Bs4Components/Bs4Utils';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useStateUxTemplate, getBoxStyle, getBoxSx} from './bs4/Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext } from './bs4/Bs4Theme/Bs4UxTemplates';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

new Bs4MainWindow();

function App(props) {
  const {dateTimeStamp: dateTimeStampTHEME} = useStateUxTemplate(TYPE_BS4_THEME);
  const {dateTimeStamp: dateTimeStampLINK} = useStateUxTemplate(TYPE_A_LINK);
  const bs4Theme = React.useMemo(() => {
    const bs4Theme = getBs4Theme();
    console.log('...Bs4Theme...', bs4Theme)

    try {
      const AndroidBs4 = Bs4MainDispatch.getAndroidBs4();
      const hexColor = colorToHex(bs4Theme.Bs4.backgroundColor);
      const luminosity = getColorLuminosity(bs4Theme.Bs4.backgroundColor);
      // console.log('...AndroidBs4...colorbg...', bs4Theme.Bs4.backgroundColor, hexColor, luminosity)
      if (AndroidBs4?.setStatusBarColor) AndroidBs4.setStatusBarColor(hexColor, luminosity > 400 ? '1' : '0');
    } catch (error) {
      console.log(error)
    }

    return bs4Theme;
  }, [dateTimeStampTHEME]);  

  const linkStyle = React.useMemo(() => {
    const uxTemplateLink = Bs4MainWindow.instance?.bs4MainWindowUx?.uxTemplateLink?.body?.Link;
    const a = getBoxSx(uxTemplateLink?.a);
    const link = getBoxSx(uxTemplateLink?.link);
    const visited = getBoxSx(uxTemplateLink?.visited);
    const hover = getBoxSx(uxTemplateLink?.hover);
    const linkStyle = {
      a: { 
        ...a,
        '&:link': {
          ...link,
        },
        '&:visited': {
          ...visited,
        },
        '&:hover': {
          ...hover,
        }
      }      
    };
    // console.log('...<a> Link...', uxTemplateLink, linkStyle)
    return linkStyle;
    return {
      a: { 
        '&:link': {
          color: 'grey',
          fontWeight: 'bold',
          // textDecoration: 'underline overline line-through 5px #00ff00',
          textDecoration: 'solid underline #ffff00 4px',
        },
        '&:visited': {
          color: 'grey',
          fontWeight: 'bold',
          // textDecoration: 'underline overline line-through 5px #00ff00',
          textDecoration: 'solid underline #ffff00 4px',
        },
        '&:hover': {
          textDecoration: 'underline',
          textDecorationThickness: '5px',
        }
      }
    }
  }, [dateTimeStampLINK]);

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // HD 
  // const maxWidth = useMediaQuery('screen and (max-width: 1280px)');  
  // const maxHeight = useMediaQuery('screen and (max-height: 720px)');

  const maxWidth = useMediaQuery('screen and (max-width: 1100px)');  
  const maxHeight = useMediaQuery('screen and (max-height: 600px)');

  // console.log('...???...S>S>...smallScreen', maxWidth, maxHeight, '...???...', document.body.clientWidth, document.body.clientHeight, maxWidth || maxHeight);
  // console.log('...???...S>S>...smallScreen', isMobile, navigator.userAgent);

  Bs4MainDispatch.speedRun((tag) => {
    console.log(Bs4MainDispatch.speedStartTime(tag), )
  }, '...App...');    
  
  return (        
    <ThemeProvider theme={bs4Theme}>
      <SmallScreenContext.Provider value={(maxWidth || maxHeight)}>        
        <SnackbarProvider 
          classes={{ containerRoot: 'bs4SnackbarContainerRoot'}}
          anchorOrigin={{vertical: 'top', horizontal: 'right',}} 
          maxSnack={maxSnack} 
          Components={{
            default: VariantBs4, 
            success: VariantBs4, 
            error: VariantBs4, 
            warning: VariantBs4, 
            info: VariantBs4,
            closeAll: VariantBs4,
          }}
        >
          <GlobalStyles styles={linkStyle} />
          <Bs4MainWindow.instance.ViewComponent/>
        </SnackbarProvider>
      </SmallScreenContext.Provider>
    </ThemeProvider>
  );
}

export default App;
